import { GAME_ECONOMY_SETTINGS } from '../../../game/GameConstants';

export function getLivesCoinCost(): number {
  return GAME_ECONOMY_SETTINGS.refillLifeCoinCost;
}
